  <div class="bread-crumb-container">
    <h2 class="margin-0">Activate or Reject User</h2>
  </div>
  <div class="global-container" [ngStyle]="{'overflow':'auto'}">
    <div class="w-100 p-t-80">
          <div class="m-3">
              <div class="example-table-container">
                  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" matSort>
          
                    <!-- ID Column -->
                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-container"> ID </th>
                      <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                    </ng-container>
                
                    <!-- name Column -->
                    <ng-container matColumnDef="name">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-container"> Name </th>
                      <td mat-cell *matCellDef="let row"> {{row.firstName}} </td>
                    </ng-container>
                
                    <!-- email Column -->
                    <ng-container matColumnDef="email">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-container"> Email </th>
                      <td mat-cell *matCellDef="let row"> {{row.email}} </td>
                    </ng-container>
                
                    <!-- activate Column -->
                    <ng-container matColumnDef="activate">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-container"> 
                          <mat-checkbox (change)="$event ? masterToggle() : null"
                                      [checked]="selection.hasValue() && isAllSelected()"
                                      [indeterminate]="selection.hasValue() && !isAllSelected()">
                                      Activate
                          </mat-checkbox> 
                      </th>
                      <td mat-cell *matCellDef="let row; let index = index"> 
                          <mat-checkbox 
                                      id = "activate-check_{{index}}"
                                      (change)="selectActivate(row,$event,index)"
                                      [checked]="selection.isSelected(row)">
                          </mat-checkbox>    
                      </td>
                    </ng-container>
      
                    <!-- reject Column -->
                    <ng-container matColumnDef="reject">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-container"> 
                          <mat-checkbox (change)="$event ? masterToggleReject() : null"
                                          [checked]="rejectSelection.hasValue() && isAllSelectedReject()"
                                          [indeterminate]="rejectSelection.hasValue() && !isAllSelectedReject()">
                                          Reject
                          </mat-checkbox>  
                      </th>
                      <td mat-cell *matCellDef="let row; let index = index"> 
                          <mat-checkbox 
                                      id = "reject-check_{{index}}"
                                      (change)="selectReject(row,$event,index)"
                                      [checked]="rejectSelection.isSelected(row)">
                          </mat-checkbox>   
                      </td>
                    </ng-container>
                
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              
                  </table>
              </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
          </div>
          <div class="row">
              <div class="text-center m-t-80">            
                <button mat-raised-button color="primary" (click)="saveActiveUser()">SAVE</button>
              </div>
          </div>
    </div>
  </div>